export default function () {
  let videos = document.querySelectorAll("video");
  for (let i = 0; i < videos.length; i++) {
    const element = videos[i];
    if (!element.getAttribute("autoplay")) {
      let parent = element.parentElement;
      let play = `<svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 565.648 565.648" height="512" viewBox="0 0 565.648 565.648" width="512"><path d="m282.824 0c-155.947 0-282.824 126.877-282.824 282.824s126.877 282.824 282.824 282.824 282.824-126.877 282.824-282.824-126.877-282.824-282.824-282.824zm-70.706 424.233v-282.822l212.118 141.41z"/></svg>`;
      let pause = `<svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 565.648 565.648" height="512" viewBox="0 0 565.648 565.648" width="512"><path d="m282.824 0c-155.947 0-282.824 126.877-282.824 282.824s126.877 282.824 282.824 282.824 282.824-126.877 282.824-282.824-126.877-282.824-282.824-282.824zm-35.353 388.883h-70.706v-212.118h70.706zm141.412 0h-70.706v-212.118h70.706z"/></svg>`;

      parent.innerHTML += `<div class="play-pause">
		<div class="play">${play}</div>
		<div class="pause">${pause}</div>
	</div>`;
    }
  }
  let playPause = document.querySelectorAll("video");

  for (let i = 0; i < playPause.length; i++) {
    const element = playPause[i];
    element.addEventListener("click", function () {
      let parent = element.parentElement;
      if (element.paused) {
        element.play();
        parent.classList.add("active");
      } else {
        element.pause();
        parent.classList.remove("active");
      }
    });
  }
}
